import { hlcInit, hlcReceive, hlcTick, type Clock, type HlcState } from '@hmawiw/shared';

let state: HlcState | null = null;

export function initClock(deviceId: string, saved: HlcState | null | undefined): HlcState {
  state = saved && saved.node === deviceId ? saved : hlcInit(deviceId);
  return state;
}

function current(): HlcState {
  if (!state) throw new Error('clock used before initClock');
  return state;
}

/** Stamp a local write. */
export function tick(now = Date.now()): Clock {
  const r = hlcTick(current(), now);
  state = r.state;
  return r.clock;
}

/** Note a clock seen from the server or another device. */
export function receive(remote: Clock, now = Date.now()): HlcState {
  state = hlcReceive(current(), remote, now);
  return state;
}

export function clockState(): HlcState {
  return current();
}
